import {useEffect} from "react"

import cn from 'clsx'

import { getValueWithCurrency } from '@App/helpers/toCurrency'
import {useAppDispatch, useAppSelector} from "@App/hooks"
import { MarketIcon } from '@App/ui/crypto_exchange/desktop/components/common/MarketIcon'
import { ToolTip } from '@App/ui/crypto_exchange/desktop/components/controls/ToolTip'

import {asyncGetTrades} from "@Redux/slices/reports/ReportsSlice"
import {selectTradesList} from "@Redux/slices/trade/trades/selectors"
import {Trade} from "@Redux/slices/trade/trades/types"
import {currentWallet} from "@Redux/slices/user/selectors"

import { formatDate, formatTime, useCopyText, useTrades } from '../../model'

import s from './styles.module.scss'

const columns: { title: string; width: string }[] = [
  { title: 'Date', width: '4%' },
  { title: 'Time', width: '2%' },
  { title: 'Market/ Size', width: '10%' },
  { title: 'Type', width: '9%' },
  { title: 'Triggered by', width: '15%' },
  { title: 'Price', width: '8%' },
  { title: 'Result', width: '3%' },
  { title: 'ID', width: '1%' },
]
export const TradesTable = ({ onRowClick }: { onRowClick?: (val: Trade) => void }) => {
  const { trades } = useTrades()
  const { copyText } = useCopyText()
  const newTrades = useAppSelector((state) => selectTradesList(state))
  const currWallet = useAppSelector(currentWallet)
  const dispatch = useAppDispatch()

  useEffect(() => {
    currWallet?.id && dispatch(asyncGetTrades(currWallet?.id))
  }, [currWallet, newTrades]);

  return (
    <div className={s.tableContainer}>
      <table className={s.table}>
        <thead>
          <tr>
            {columns.map((col) => (
              <th style={{ width: col.width }} key={col.title} className={s[col.title.toLocaleLowerCase()]}>
                {col.title}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {trades.map((trade) => (
            <tr className={s.row} key={trade.id} onClick={() => onRowClick?.(trade)}>
              <td className={s.col}>{formatDate(trade.open_time)}</td>
              <td className={s.col}>{formatTime(trade.open_time)}</td>
              <td className={cn(s.col, s.info)}>
                <MarketIcon
                  source_currency={trade.market.source}
                  target_currency={trade.market.target}
                />{' '}
                {trade.market.title}
                <span className={cn(s.quantity, trade.action_type === 'buy' && s.buy)}>{trade.quantity}</span>
              </td>
              <td className={s.col}>{trade.status}</td>
              <td className={s.col}>user</td>
              <td className={s.col}>{trade.open_rate}</td>
              <td className={cn(s.col, s.result, trade.result < 0 && s.negative)}>
                {getValueWithCurrency(trade.currency, trade.result)}
              </td>
              <td className={s.col}>
                <ToolTip content={<span className={s.toolTip}>{trade.front_id}</span>}>
                  <span className={s.idBadge} onClick={() => copyText(trade.front_id)}>
                    ID
                  </span>
                </ToolTip>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
